import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ChatBubblePageRoutingModule } from './chat-bubble-routing.module';

import { ChatBubblePage } from './chat-bubble.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ChatBubblePageRoutingModule
  ],
  declarations: [ChatBubblePage],
  exports :[ChatBubblePage]
})
export class ChatBubblePageModule {}
